import { fetchOrganizationSettings } from "@/libs/api/requests";
import { OrganizationSettings, SettingsResponse } from "@/libs/api/types";
import { useUser } from "@/libs/auth/data/user";
import {
  createContext,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from "react";

interface SettingsContextType {
  getSettingValue: (option: OrganizationSettings) => any;
}

export const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined,
);

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<SettingsResponse | undefined>(
    undefined,
  );

  const { isLoggedIn, isInitialized } = useUser();

  const getSettingValue = useCallback(
    (option: OrganizationSettings) => {
      if (!settings) {
        return;
      }

      return settings.global[option];
    },
    [settings],
  );

  useEffect(() => {
    if (!isLoggedIn || !isInitialized) {
      return;
    }

    fetchOrganizationSettings().then((settings) => {
      setSettings(settings);
    });
  }, [isInitialized, isLoggedIn]);

  return (
    <SettingsContext.Provider value={{ getSettingValue }}>
      {children}
    </SettingsContext.Provider>
  );
}
